import { gql } from 'graphql.macro';

export const panNumbersTemplate = gql`
    query panNumbers {
        panNumbers {
            _id
            value
            description
        }
    }
`;

export const panNumberFeatureStatusTemplate = gql`
    query panNumberFeatureStatus {
        currentLab {
            panNumberEnabled
        }
    }
`;
